export default __webpack_public_path__ + "static/media/Xqg8.4d75764d.gif";